import {takeEvery} from "redux-saga/effects";
import {fetchMainStore, fetchStores} from "./stores.saga";
import * as types from "../types/stores.types";
import {
    activeCodeUserSaga, fetchInvitation, fetchMyDiscounts,
    fetchShowMyDiscounts, loginUserSaga, resendCodeUserSaga
} from "./user.saga";

export default function* rootSaga() {
    /*STORES*/
    yield takeEvery(types.FETCH_STORES, fetchStores);
    yield takeEvery(types.FETCH_MAIN_STORE, fetchMainStore);

    /*User*/
    yield takeEvery(types.LOGIN_USER, loginUserSaga);
    yield takeEvery(types.ACTIVE_CODE, activeCodeUserSaga);
    yield takeEvery(types.RESEND_CODE, resendCodeUserSaga);
    yield takeEvery(types.FETCH_MY_DISCOUNTS, fetchMyDiscounts);
    yield takeEvery(types.FETCH_SHOW_MY_DISCOUNT, fetchShowMyDiscounts);
    yield takeEvery(types.FETCH_INVITATION_LINK, fetchInvitation);
}